import React, {useEffect, useRef, useState} from 'react'
import {Button, Checkbox, Input, message, Modal, Space, Table, Tag} from 'antd';
import {
    bookPhoneNumber,
    getListShortPhoneByTenant,
    getListTenantNumber
} from "../../../../../../services/api/apiCustomerHub";
import parseToken from "../../../../../../helpers/parseToken";
import {QuestionCircleOutlined, SearchOutlined} from "@ant-design/icons";
import BookShortPhoneModal from "./BookShortPhoneModal";

function BookNumberModal(props) {
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(selectedRowKeys, selectedRows)
            setSelectedRowKeys(selectedRows)
        }
    };
    const decodeToken = parseToken()
    const [isChargeSub, setIsChargeSub] = useState(true)
    const [isChargeReg, setIsChargeReg] = useState(true)
    const [isMasterNumber, setIsMasterNumber] = useState(false)
    const {showModal, toggleModal, fetchListTenantNumber, custId} = props
    const [loading, setLoading] = useState(false)
    const [listTenantNumber, setListTenantNumber] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [listVirtualNumber, setListVirtualNumber] = useState([])
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                text
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'Hotline',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            sorter: (a, b) => a.address.length - b.address.length,
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('phoneNumber'),
        },
        {
            title: 'Brand name',
            dataIndex: 'brandName',
            key: 'brandName',
            ...getColumnSearchProps('brandName'),
        },
        {
            title: 'Mạng',
            dataIndex: 'telco',
            key: 'telco',
            ...getColumnSearchProps('telco'),
        },
        {
            title: 'source',
            dataIndex: 'source',
            key: 'source',
            ...getColumnSearchProps('source'),
        },
        {
            title: 'Trạng thái',
            dataIndex: 'actions',
            key: 'actions',
            ...getColumnSearchProps('strStatus'),
            render: (text, record) => {
                return mapStatus(record.status, record.strStatus)
            }
        },
        {
            title: 'Trạng thái gọi VTL',
            dataIndex: 'statusLockVTL',
            key: 'statusLockVTL',
            ...getColumnSearchProps('statusLockVTL'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockVTL)
            }
        },
        {
            title: 'Số lần mở VTL',
            dataIndex: 'blockedNumVTL',
            key: 'blockedNumVTL',
            ...getColumnSearchProps('blockedNumVTL'),
        },
        {
            title: 'Trạng thái gọi MBF',
            dataIndex: 'statusLockMBF',
            key: 'statusLockMBF',
            ...getColumnSearchProps('statusLockMBF'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockMBF)
            }
        },
        {
            title: 'Số lần mở MBF',
            dataIndex: 'blockedNumMBF',
            key: 'blockedNumMBF',
            ...getColumnSearchProps('blockedNumMBF'),
        },
        {
            title: 'Trạng thái gọi VNA',
            dataIndex: 'statusLockVNA',
            key: 'statusLockVNA',
            ...getColumnSearchProps('statusLockVNA'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockVNA)
            }
        },
        {
            title: 'Số lần mở VNA',
            dataIndex: 'blockedNumVNA',
            key: 'blockedNumVNA',
            ...getColumnSearchProps('blockedNumVNA'),
        },
        {
            title: 'Khách hàng trước đó',
            dataIndex: 'prevTenantName',
            key: 'prevTenantName',
            ...getColumnSearchProps('prevTenantName'),
        },
    ];

    const mapStatus = (value, status) => {
        // eslint-disable-next-line default-case
        switch (value) {
            case 0:
                return <Tag color="#531dab">{status}</Tag>
            case 1:
                return <Tag color="#108ee9">{status}</Tag>
            case 2:
                return <Tag color="#2db7f5">{status}</Tag>
            case 3:
                return <Tag color="#f50">{status}</Tag>
            case 8:
                return <Tag color="#9100ff">{status}</Tag>
            case 9:
                return <Tag color="#d4380d">{status}</Tag>
            case -1:
                return <Tag color="#87d068">{status}</Tag>
        }
    }

    const mapStatusLock = (value) => {
        switch (value) {
            case 'Khóa':
                return <Tag color="#ff0000">{value}</Tag>
            case 'Hoạt động':
                return <Tag color="#108ee9">{value}</Tag>
            default:
                return <Tag color="#000000">{value}</Tag>
        }
    }

    const _fetchListTenantNumber = async () => {
        setLoading(true)
        try {
            const payload = {
                lstStatus: [0, 8]
            }
            const response = await getListTenantNumber(decodeToken.sub, payload)
            const {success, data, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }
            setLoading(false)
            setListTenantNumber(data.map((item, index) => {
                return {
                    key: index,
                    ...item
                }
            }))
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _onConfirmCancel = () => {
        Modal.confirm({
            title: 'Xác nhận',
            icon: <QuestionCircleOutlined/>,
            content: `Bạn có chắc muốn thoát không ?`,
            okText: 'Thoát',
            cancelText: 'Huỷ',
            async onOk() {
                await toggleModal()
            }
        })
    }

    const _onConfirmBookNumber = () => {
        if (selectedRowKeys?.length > 1 && isMasterNumber) {
            Modal.confirm({
                title: 'Xác nhận',
                icon: <QuestionCircleOutlined/>,
                content: `Số lượng đang lớn hơn > 1 (${selectedRowKeys?.length}) , bạn có chắc muốn book không ?`,
                okText: 'Book',
                cancelText: 'Huỷ',
                async onOk() {
                    await onBookNumber()
                }
            })
        } else {
            onBookNumber()
        }

    }

    const onBookNumber = async () => {
        setLoading(true)
        try {
            const payload = {
                tenantId: custId
            }
            const response = await getListShortPhoneByTenant(decodeToken.sub, payload)
            const {success, data, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }
            setLoading(false)
            let _bookNumber = ''
            if (data.length > 1) {
                setListVirtualNumber(data.map((item, index) => {
                    return {
                        key: index,
                        ...item
                    }
                }))
            } else {
                if (data.length === 1) {
                    _bookNumber = data[0]?.shortPhone || ''
                }
                await handleBookNumber(_bookNumber)
            }
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const handleBookNumber = async (_bookPhoneNumber) => {
        setLoading(true)
        try {
            const payload = {
                lstId: selectedRowKeys.map(item => item.id),
                phone: selectedRowKeys.map(item => item.phoneNumber),
                isChargeSub: isChargeSub ? 1 : 0,
                isChargeReg: isChargeReg ? 1 : 0,
                shortPhone: _bookPhoneNumber,
                tenantId: custId,
                isMasterNumber: isMasterNumber ? 1 : 0,
            }
            const response = await bookPhoneNumber(decodeToken.sub, payload)
            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }
            message.success('Book số thành công!')
            setLoading(false)
            toggleModal()
            fetchListTenantNumber()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const onChangeSub = (e) => {
        setIsChargeSub(e.target.checked)
    }

    const onChangeRegister = (e) => {
        setIsChargeReg(e.target.checked)
    }

    const onChangeMasterNumber = (e) => {
        setIsMasterNumber(e.target.checked)
    }

    useEffect(() => {
        _fetchListTenantNumber()
        // eslint-disable-next-line
    }, [])

    return <>
        {listVirtualNumber.length > 0 ?
            <BookShortPhoneModal
                toggleModal={toggleModal}
                showModal={showModal}
                loading={loading}
                listVirtualNumber={listVirtualNumber}
                handleBookNumber={handleBookNumber}
            /> : (
                <Modal
                    title="Book số"
                    className={`ModalCustom2 ModalBookNumber`}
                    style={{top: 20}}
                    maskClosable={false}
                    width="90%"
                    open={showModal}
                    footer={[
                        <div className="Actions d-flex justify-content-end align-items-center">
                            <Checkbox
                                disabled={selectedRowKeys.length === 0}
                                checked={isMasterNumber}
                                onChange={onChangeMasterNumber}
                            >
                                Số chủ
                            </Checkbox>
                            <Checkbox disabled={selectedRowKeys.length === 0} checked={isChargeSub} onChange={onChangeSub}>
                                Tính cước sub
                            </Checkbox>
                            <Checkbox disabled={selectedRowKeys.length === 0} checked={isChargeReg} onChange={onChangeRegister}>
                                Tính cước register
                            </Checkbox>
                            <Button onClick={_onConfirmBookNumber} key="submit" type="primary" loading={loading}
                                    disabled={selectedRowKeys.length === 0}>
                                Book số
                            </Button>
                            <Button key="back" type="link" onClick={_onConfirmCancel}>
                                Cancel
                            </Button>
                        </div>
                    ]}
                >
                    <div className="FormAddNew">
                        {listTenantNumber.length > 0 && (
                            <>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div
                                        className="total mb-2">{selectedRowKeys.length > 0 && `${selectedRowKeys.length} selected`}</div>
                                    <div className="total mb-2">{listTenantNumber.length} items</div>
                                </div>
                                <Table
                                    rowSelection={{
                                        type: "checkbox",
                                        ...rowSelection,
                                    }}
                                    columns={columns}
                                    dataSource={listTenantNumber}
                                />
                            </>
                        )}
                    </div>
                </Modal>
            )}
    </>
}

export default BookNumberModal
